import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { useApi } from "../hooks/useApi";
import useMy from "../hooks/useMy";
import { authType } from "./Login";
import LineBox from "../components/DefaultStyles/LineBox";
import TitleWithLine from "../components/DefaultStyles/TitleWithLine";
import SpaceBetween from "../components/DefaultStyles/SpaceBetween";
import LineBtn from "../components/Button/LineBtn";
import Blank from "../components/DefaultStyles/Blank";
import RadioBtn from "../components/Button/RadioBtn";
import styled from "styled-components";
import Table, { TableBody, TableBodyItem } from "../components/Table/Table";
import Pagination from "../components/Table/Pagination";
import { IBlackListInfo } from "./Users/BlackList";
import Loader from "../components/DefaultStyles/Loader";
import BlackListModal from "../components/pages/Users/UserDetail/BlackListModal/BlackListModal";
import { TotalCount } from "./Users/UserInfo";
import { getThousandComma } from "../ApiTS/ApiCommonTS";
import DailyCheckList from "../components/pages/Home/DailyCheckList";
import UnResolvedComment from "../components/pages/Home/UnResolvedComment";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const { grade } = useMy();
  const navigate = useNavigate();

  const [auth, setAuth] = useRecoilState(authType);
  const [blackPage, setBlackPage] = useState(0);
  const [blacklistModal, setBlacklistModal] = useState(false);
  const [blacklistData, setBlacklistData] = useState<IBlackListInfo>();
  const [blacklist_viewType, setBlacklistViewType] = useState<0 | 1>(0); //(1: 종료된 대상만, 0: 종료되지 않은 대상만)

  const { response, loading } = useApi({
    method: "get",
    url: grade ? `auth/detail?id=${grade}` : undefined,
  });

  const {
    response: blacklistResponse,
    loading: blacklistLoading,
    fetchData: blacklistFetchData,
  } = useApi({
    method: "get",
    url: auth?.black ? `black-list?page=${blackPage}&size=5&isExpired=${blacklist_viewType}` : undefined,
  });

  useEffect(() => {
    if (response) {
      setAuth(response?.data[0]);
    }
  }, [response]);

  return (
    <div>
      <LineBoxContainer>
        <DailyCheckList />
      </LineBoxContainer>

      <Blank blankHeight={30} />

      {auth?.comment && (
        <ListContainer>
          <UnResolvedComment />
        </ListContainer>
      )}

      <Blank blankHeight={30} />

      {auth?.black && (
        <ListContainer>
          <LineBox>
            <TitleWithLine title="블랙리스트" />

            <Blank blankHeight={24} />

            <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
              <RadioBtn
                label="현재 유저"
                clickEvent={() => setBlacklistViewType(0)}
                check={blacklist_viewType === 0}
                noTooltip={true}
              />
              <RadioBtn
                label="종료 유저"
                clickEvent={() => setBlacklistViewType(1)}
                check={blacklist_viewType === 1}
                noTooltip={true}
              />
            </div>

            <Table
              tableMinWidth={520}
              tableHeadData={["UID_이름_닉네임", "내용", "상세"]}
            >
              <>
                {blacklistResponse?.data?.items?.map(
                  (b: IBlackListInfo, i: number) => (
                    <TableBody key={i}>
                      <TableBodyItem
                        clickable
                        onClick={() => navigate(`/users/info/${b?.uid}`)}
                      >
                        {b?.uid}_{b?.name}_{b?.nickname}
                      </TableBodyItem>
                      <TableBodyItem>{b?.reason}</TableBodyItem>
                      <TableBodyItem>
                        <LineBtn
                          btnText="상세"
                          btnClickEvent={() => {
                            setBlacklistData(b);
                            setBlacklistModal(true);
                          }}
                        />
                      </TableBodyItem>
                    </TableBody>
                  )
                )}
              </>
            </Table>

            <SpaceBetween>
              <Pagination
                currentPage={blackPage}
                pageClickEvent={(index) => setBlackPage(index)}
                totalPage={
                  blacklistResponse?.status === 200 &&
                  blacklistResponse?.data?.totalPage < 3
                    ? blacklistResponse?.data?.totalPage
                    : 3
                }
              />
              <TotalCount>
                총{" "}
                {getThousandComma(
                  blacklistResponse?.status === 200
                    ? +blacklistResponse?.data?.totalCount
                    : 0
                )}
                개
              </TotalCount>
            </SpaceBetween>
          </LineBox>
        </ListContainer>
      )}

      {(blacklistLoading || loading) && <Loader />}

      {/* 블랙리스트 상세 모달 */}
      {blacklistModal && (
        <BlackListModal
          closeEvent={() => setBlacklistModal(false)}
          confirmEvent={() =>
            blacklistFetchData({
              method: "get",
              url: auth?.black
                ? `black-list?page=${blackPage}&size=5&isExpired=${blacklist_viewType}`
                : undefined,
            })
          }
          blacklistData={blacklistData}
          type="view"
        />
      )}
    </div>
  );
}

const LineBoxContainer = styled.div`
  max-width: 420px;
`;

const ListContainer = styled.div`
  max-width: 640px;
`;
